import { differenceInWeeks, intlFormatDistance } from 'date-fns';
import { useCallback, useMemo } from 'react';

import formatDate from 'utils/format-date';
import parseDate from 'utils/parse-data';

interface Options {
    time?: boolean;
}

export default function useFormatDate(options?: Options) {
    const now = useMemo(() => new Date(), []);
    const time = options?.time ?? true;

    return useCallback(
        (date: Date | string | number) => {
            date = parseDate(date);
            if (differenceInWeeks(date, now)) {
                return time ? formatDate(date, 'yyyy/MM/dd h:m aaaa') : formatDate(date, 'yyyy/MM/dd');
            } else {
                return intlFormatDistance(date, now);
            }
        },
        [now, time]
    );
}
